export const defaultStyles = {
  colors: {
    dark: "#333",
    default: "#009999",
    light: "#eee",
    selected: "#a83232",
  },
  font: "16px Roboto, sans-serif",
  icon: {
    scale: 0.4,
    size: 64,
  },
  strokeWidth: 3,
};
